<template>
    <div>
       
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="merchant" label-position="right" label-width="120px" :model="merchant" :rules="rules">
                <input type="hidden" :model="merchant.id" />
                
                 <el-form-item label="登录名" prop="loginName">
                    <el-row>
                        <el-col :span="8"><el-input disabled v-model="merchant.loginName" placeholder="登录名" /></el-col>
                    </el-row>
                </el-form-item>
                 <el-form-item label="手机号码" prop="phone">
                    <el-row>
                        <el-col :span="8"><el-input disabled v-model="merchant.phone" placeholder="手机号码" /></el-col>
                    </el-row>
                </el-form-item>
               
            </el-form>
           
        </Content>
    </div>
</template>
<script>
import api from '@/api/api';
export default {
    name: 'Merchant',
    data() {
        return {
            loading: false,
            modalLoading: false,

            others: {

            },
            merchant: {

            },
            rules: {

            },

        };
    },
    mounted: function() {

        this.getDetail();

    },
    methods: {
        cbtime: function(value) {
            this.others;
        },
        getDetail: function() {
   
            var me = this;
           
           
            me.showLoading();
            me.$http.post(api.userInfo).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.merchant = body.obj;

                }
                else{
                    me.errorMessage(body.info);
                }
                me.hideLoading();
            }, response => {
                me.hideLoading();
            });
        }

    }
}
</script>
<style scoped>
</style>